<template>
  <div class="category-holder">
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-small is-left">
              <i class="mdi mdi-magnify"></i>
            </span>
            <input
              class="input"
              type="text"
              placeholder="Buscar produto"
              v-model.trim="searchText"
            />
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="buttons is-right"></div>
      </div>
      <div class="column is-12" v-if="stocks.length">
        <div>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Receita</th>
                <th>Tamanho</th>
                <th>Lote</th>
                <th>Produzido</th>
                <th>Saída</th>
                <th>Em estoque</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="stock in stocks" :key="stock.id">
                <td>{{ stock.receipt }}</td>
                <td>{{ stock.packingSize }}g</td>
                <td>{{ stock.batch }}</td>
                <td>{{ stock.quantity }}</td>
                <td>{{ stock.used }}</td>
                <td>{{ stock.quantity - stock.used }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <paginate
          v-model="currentPage"
          :page-count="totalPages"
          :page-range="3"
          :click-handler="getData"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'ml-pagination pagination-sm'"
          :prev-class="'page-item'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
      <div class="column is-12" v-else>
        <div class="no-items-to-show-msg">Nenhum produto encontrado.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "../services/HttpServices";
import QueryBuilder from "../helpers/QueryBuilder";
import utils from "../helpers/debounce";

export default {
  name: "Stock",
  data: () => ({
    currentPage: 1,
    searchText: "",
    stocks: [],
    querySize: 50
  }),
  watch: {
    searchText: function() {
      this.getStockByText();
    }
  },
  methods: {
    getData(pageNum) {
      const page = pageNum - 1;
      this.currentPage = pageNum;
      this.getStocks(page);
    },
    getStocks(page) {
      if (!page) {
        page = 0;
      }

      let query = { size: this.querySize, page: page };
      if (this.searchText.length > 0) {
        query.receipt = this.searchText;
      }
      let queryParamString = QueryBuilder.getQueryString(query);
      HTTP.get(`/packedproducts${queryParamString}`).then(({ data }) => {
        this.stocks = data.content;
        this.totalPages = data.totalPages;
      });
    }
  },
  mounted() {
    this.getStockByText = utils.debounce(() => {
      let query = { size: this.querySize, page: 0, receipt: this.searchText };
      let queryParamString = QueryBuilder.getQueryString(query);

      HTTP.get(`/packedproducts${queryParamString}`).then(({ data }) => {
        this.stocks = data.content;
        this.totalPages = data.totalPages;
      });
    }, 300);
  },
  created() {
    this.$store.commit("setSelectedViewTitle", "Estoque");
    this.getStocks();
  }
};
</script>

<style lang="scss" scoped></style>
